// Helper function to filter only new file uploads (files without id property)
export const getNewFileUploads = (
  files: Array<{ id?: string }> | undefined
): Array<{ id?: string }> => {
  return files?.filter((file) => !('id' in file)) || []
}
